module.exports = __webpack_public_path__ + "static/media/triskal_white.ad1357fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/triskal_white.png
// module id = 68
// module chunks = 0